import { memoizeFunction } from '@agilepoint/utils-common';

const NON_DIGIT_REGEX = /\D/g;
export const extractNumberAsString = (input: string) => input.replace(NON_DIGIT_REGEX, '');

export const generateGridTemplate = memoizeFunction((mainIconExists: boolean, clearIconExists: boolean, reversed: boolean) => {
    const columnTemplate: string[] = [];
    if (mainIconExists) {
        columnTemplate.push('auto');
    }
    columnTemplate.push('minmax(0,1fr)');
    if (clearIconExists) {
        columnTemplate.push('auto');
    }
    return `1fr/${(reversed ? columnTemplate.reverse() : columnTemplate).join(' ')}`;
});


export function setNativeValue(element: HTMLElement, value: string) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter?.call(element, value);
        return;
    }
    valueSetter?.call(element, value);
}

export function insertCharAt(str: string, char: string, index: number) {
    return str.substring(0, index) + char + str.substring(index + 1);
}
